import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { z } from "zod";
import CheckCircle from "~icons/material-symbols/check-circle-outline";
import { css } from "../../../../styled-system/css";
import Header from "../../../components/header";
import { useFooter } from "../../../contexts/footer-context";
import { t } from "../../../libs/i18n";
import { getServiceURL } from "../../../libs/ps";

const searchSchema = z.object({
  serviceId: z.string().uuid(),
  u: z.string().optional(),
});

type SubscribeSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_authed/subscribe/")({
  component: RouteComponent,
  validateSearch: (search) => searchSchema.parse(search),
  loaderDeps: ({ search }) => ({
    search: search as SubscribeSearch,
  }),
  loader: async ({ context: { tenant }, deps: { search } }) => {
    const { serviceId, u } = search;
    const serviceUrl = getServiceURL(serviceId, u);

    return {
      tenant,
      serviceUrl,
    };
  },
});

function RouteComponent() {
  const { setDisabled } = useFooter();
  const { tenant, serviceUrl } = Route.useLoaderData();

  useEffect(() => {
    setDisabled(true);

    return () => {
      setDisabled(false);
    };
  }, [setDisabled]);

  return (
    <>
      <Header title={tenant.name} />
      <div
        className={css({
          textAlign: "center",
          p: "24px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
        })}
      >
        <div
          className={css({
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          })}
        >
          <CheckCircle
            className={css({
              color: "text.accentSuccess",
              w: "96px",
              h: "96px",
              mx: "auto",
            })}
          />
          <h1
            className={css({
              fontSize: "20px",
              fontWeight: "bold",
            })}
          >
            {t("登録が完了しました")}
          </h1>
        </div>
        <p
          className={css({
            textAlign: "left",
          })}
        >
          {t(
            "地域ポイントミニアプリの登録が完了しました。下のボタンから元のミニアプリに戻ってください。",
          )}
        </p>
        <a
          href={serviceUrl}
          className={css({
            bg: "text.accentPrimary",
            color: "text.inverse",
            py: "12px",
            px: "28px",
            fontSize: "16px",
            borderRadius: "16px",
            w: "100%",
            display: "block",
            textDecoration: "none",
          })}
        >
          {t("元のミニアプリに戻る")}
        </a>
      </div>
    </>
  );
}
